<template>
    <div class="filter-free-mileage-box px-3 position-relative">
        <p class="mb-2"><b>{{$t('cat.filter.free_mileage')}}</b></p>
        <p class="filter-reset-icon" v-if="hasChanged">
            <font-awesome-icon icon="fa-minus-circle" class="text-link" @click="resetFilter"/>
        </p>
        <div class="row">
            <div class="col-12">
                <b-skeleton
                    v-if="isLoading && value === null"
                    height="14px"
                    width="100%"
                ></b-skeleton>
                <vue-slider
                    :min="min"
                    :max="max"
                    v-model="value"
                    :enableCross="false"
                    tooltip="none"
                    :data="data"
                    :data-value="'value'"
                    :data-label="'name'"
                ></vue-slider>
            </div>
            <div class="col-12 d-flex justify-content-between">
                <span>{{getMinValue}}</span>
                <span>{{getMaxValue}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { BSkeleton } from "bootstrap-vue"
import { EventBus } from "../../event-bus"
import VueSlider from "vue-slider-component";
import { conditionalExpression } from "@babel/types";

export default {
    name: 'FilterFreeMileageBox',
    components: {
        BSkeleton,
        VueSlider
    },
    data() {
        return {
            appendContent: 'km',
            changedByUrl: false,
            filterData: null,
            value: null,
            min: 0,
            max: 9999,
            isLoading: true,
            setup: true,
            tooltipFormat: '',
            marks: [],
            data: [],
            dataLoader: null,
            hasChanged: false
        }
    },
    methods: {
        getFilterData(data){
            this.filterData = data.find(f => f.name === 'mileage')
            let sortedValues = this.filterData.values.sort(function (a, b) {
                return a.miles - b.miles;
            });
            
            if(sortedValues[0].default) {
                sortedValues.shift()
            }

            sortedValues.forEach(value => {
                this.data.push({
                    value: value.id,
                    name: value.miles
                })
            })

            if (sortedValues.length > 1) {
                this.min = sortedValues[0].miles
                this.max = sortedValues[sortedValues.length - 1].miles
            }

           if(this.$route.query.mileage){
                this.changedByUrl = true
                const values = this.$route.query.mileage.replace(/[^0-9\,]/g, '').split(',')

                if(values.length == 1 && values[0] == "1"){
                    this.value = [this.data[0], this.data[this.data.length -1]]
                } else {
                    this.hasChanged = true
                    if(values[0] > this.max || values[1] > this.max){
                        this.value = [0, this.max]
                    } else {
                        const min = this.data.find(d => d.value === parseInt(values[0]))
                        const max = this.data.find(d => d.value === parseInt(values[1]))
                        this.value = [min, max]
                    }
                }
            } else {
                this.value = [this.data[0], this.data[this.data.length -1]]
            }

            this.isLoading = false
        },
        resetFilter(){
            this.hasChanged = false
            const min = this.data.find(d => d.name === parseInt(this.min))
            const max = this.data.find(d => d.name === parseInt(this.max))
            this.value = [min, max]

            this.changedByUrl = true
            EventBus.$emit('update-catalog-filter', {filter: 'mileage', value: `-1`})
        }
    },
    computed: {
        // TODO re-add smaller tooltips when needed
        // getTooltip(){
        //     return this.value === null ? '' : `${this.value[0].name} - ${this.value[1].name} ${this.$t('cat.filter.free_mileage.tooltip.unit')}`
        // },
        getMinValue(){
            return this.value ? `${this.$n(this.value[0].name)} ${this.$root.whitelabel.getMileageUnit()}` : ''
        },
        getMaxValue(){
            return this.value ? `${this.$n(this.value[1].name)} ${this.$root.whitelabel.getMileageUnit()}` : ''
        }
    },
    watch: {
        value: function (val) {
            // fallback if order is set by url
            if(!this.changedByUrl && this.value !== null){
                if(!this.setup){
                    this.hasChanged = true
                    if(this.dataLoader) {
                        clearTimeout(this.dataLoader);
                    }
                    this.dataLoader = setTimeout(() => {
                        EventBus.$emit('update-catalog-filter', {filter: 'mileage', value: `[${this.value[0].value},${this.value[1].value}]`})
                    }, 500)
                } else {
                    this.setup = false
                }
            } else {
                this.changedByUrl = false
            }
        },
    },
    mounted() {
        EventBus.$on('catalog-filters-received', this.getFilterData);
        EventBus.$on('catalog-filters-reset', this.resetFilter);
    }
}
</script>
